
export const setClipboard = async (
  value: string,
  type: 'text/plain' | 'text/html' = "text/plain"
) => {
  const blob = new Blob([value], { type });
  const data = [new ClipboardItem({ [type]: blob })];
  await navigator.clipboard.write(data);
};
